import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AsignacionesV2Service from "../services/asignacionesV2";

const headStyle: React.CSSProperties = {
  background: "#910434",
  color: "whitesmoke",
  fontWeight: "bold",
};

// Lista de puntos de servicio asignados al fiscal. Al hacer clic en una fila
// guarda el PS en sessionStorage y navega al detalle (estilo EMSYS).
const ListaPuntosServicio: React.FC = () => {
  const history = useHistory();
  const [puntos, setPuntos] = useState<any[]>([]);
  const [filtro, setFiltro] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    (async () => {
      const datos = await AsignacionesV2Service.listaPuntos();
      setPuntos(datos);
    })();
  }, []);

  const filtrados = puntos.filter((p) =>
    `${p.ps_nombre || ""} ${p.ps_codigo || ""}`.toLowerCase().includes(filtro.toLowerCase())
  );

  const abrirDetalle = (p: any) => {
    sessionStorage.setItem("ps_id", p.ps_id);
    sessionStorage.setItem("ps_nombre", p.ps_nombre || "");
    history.push("/asignaciones-v2-detalle");
  };

  return (
    <Paper style={{ width: "100%" }}>
      <Box p={1}>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Buscar punto de servicio"
          value={filtro}
          onChange={(e) => {
            setFiltro(e.target.value);
            setPage(0);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <TableContainer style={{ maxHeight: 560 }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell style={headStyle}>Código</TableCell>
              <TableCell style={headStyle}>Punto de Servicio</TableCell>
              <TableCell style={headStyle} align="center">Operarios</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filtrados
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((p, idx) => (
                <TableRow hover key={`${p.ps_id}-${idx}`} style={{ cursor: "pointer" }} onClick={() => abrirDetalle(p)}>
                  <TableCell>{p.ps_codigo}</TableCell>
                  <TableCell>{p.ps_nombre}</TableCell>
                  <TableCell align="center">{p.cantidad}</TableCell>
                </TableRow>
              ))}
            {filtrados.length === 0 && (
              <TableRow>
                <TableCell colSpan={3} align="center">Sin puntos de servicio</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={filtrados.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(_e, newPage) => setPage(newPage)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
      />
    </Paper>
  );
};

export default ListaPuntosServicio;
